<svg
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 24 24"
  fill="none"
  focusable="false"
  aria-hidden="true"
>
  <path
    [attr.fill]="fillColor"
    d="m21.253 13.617-8.423 8.424c-.46.459-1.2.459-1.66 0l-8.423-8.424-.83-.83A6.52 6.52 0 0 1 0 8.162c0-1.674.637-3.352 1.917-4.627a6.544 6.544 0 0 1 9.253 0c.46.46 1.2.46 1.66 0a6.544 6.544 0 0 1 9.253 0A6.512 6.512 0 0 1 24 8.161a6.512 6.512 0 0 1-1.917 4.627l-.83.83-8.423 8.423c-.46.459-1.2.459-1.66 0l-8.423-8.424"
  />
</svg>
